import { makeStyles } from '@material-ui/styles';

type WeekdayHeaderProps = {
  label: string;
};

const useStyles = makeStyles({
  weekdayLabel: {
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
});

const WeekdayHeader = ({ label }: WeekdayHeaderProps) => {
  const classes = useStyles();
  return <span className={classes.weekdayLabel}>{label}</span>;
};

export default WeekdayHeader;
